import { render, staticRenderFns } from "./HeroBarMain.vue?vue&type=template&id=6d2b01fa&scoped=true&"
import script from "./HeroBarMain.vue?vue&type=script&lang=js&"
export * from "./HeroBarMain.vue?vue&type=script&lang=js&"
import style0 from "./HeroBarMain.vue?vue&type=style&index=0&id=6d2b01fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b01fa",
  null
  
)

export default component.exports